/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'commerce.credit-card-base.error-message.error': 'We are not able to use this credit card {br} Try again or use another one.',
  'commerce.credit-card-base.form.error.contactSupport': 'Contact support',
  'commerce.credit-card-base.form.error.content': "We're sorry, we can't load the credit card form right now.",
  'commerce.credit-card-base.form.error.retry': 'Try again',
  'commerce.credit-card-base.form.error.title': 'Problem connecting',
  'commerce.credit-card-base.form.fieldCardNumber': 'Card number',
  'commerce.credit-card-base.form.fieldCvc': 'Security code',
  'commerce.credit-card-base.form.fieldExpirationDate': 'Expiration date',
  'commerce.credit-card-base.form.fieldName': 'Name on card',
  'commerce.credit-card-base.form.frame-breaker.contactSupportText': 'Contact support',
  'commerce.credit-card-base.form.frame-breaker.content': "We've detected an insecure environment and are not able to display the credit card form.",
  'commerce.credit-card-base.form.frame-breaker.title': 'Unable to continue',
  'commerce.credit-card-base.form.labelCardholderName': 'Cardholder name',
  'commerce.credit-card-base.two-line-form.error.contactSupport': 'Contact support',
  'commerce.credit-card-base.two-line-form.error.content': "We're sorry, we can't load the credit card form right now.",
  'commerce.credit-card-base.two-line-form.error.retry': 'Try again',
  'commerce.credit-card-base.two-line-form.error.title': 'Problem connecting',
  'commerce.credit-card-base.two-line-form.fieldCardNumber': 'Credit card number',
  'commerce.credit-card-base.two-line-form.fieldCvc': 'Security code',
  'commerce.credit-card-base.two-line-form.fieldExpirationDate': 'Expiration date',
  'commerce.credit-card-base.two-line-form.fieldName': 'Name on card',
  'commerce.credit-card-base.two-line-form.frame-breaker.contactSupportText': 'Contact support',
  'commerce.credit-card-base.two-line-form.frame-breaker.content': "We've detected an insecure environment and are not able to display the credit card form.",
  'commerce.credit-card-base.two-line-form.frame-breaker.title': 'Unable to continue',
  'commerce.credit-card-base.two-line-form.labelCardholderName': 'Cardholder name'
};